import {Bindings} from "data/constants/bindings";
import type {
	IGetShareImageParams,
	IPredictionApiProvider,
	IShareImage,
} from "data/providers/api/predictions.api.provider";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable, runInAction, action} from "mobx";

export interface ISharingStore {
	get isLoading(): boolean;

	get isFetched(): boolean;

	get shareImage(): IShareImage["shareImage"] | null;

	get shareWinnerImage(): IShareImage["shareImage"] | null;

	requestImage(params: IGetShareImageParams): Promise<void>;

	requestWinnerImage(params: IGetShareImageParams): Promise<void>;
}

@injectable()
export class SharingStore implements ISharingStore {
	@observable private _isLoading: boolean = false;
	@observable private _isFetched: boolean = false;

	@observable _shareImage: IShareImage["shareImage"] | null = null;
	@observable _winnerShareImage: IShareImage["shareImage"] | null = null;

	constructor(
		@inject(Bindings.PredictionApiProvider)
		private _predictionApiProvider: IPredictionApiProvider
	) {
		makeAutoObservable(this);
	}

	public get isFetched(): boolean {
		return this._isFetched;
	}

	public get isLoading(): boolean {
		return this._isLoading;
	}

	get shareImage(): IShareImage["shareImage"] | null {
		return this._shareImage;
	}

	get shareWinnerImage(): IShareImage["shareImage"] | null {
		return this._winnerShareImage;
	}

	@action
	async requestImage(params: IGetShareImageParams) {
		if (!params.contestId) {
			return;
		}
		const {data} = await this._predictionApiProvider.getShareImage(params);

		runInAction(() => {
			this._shareImage = data.success.shareImage;
		});
	}

	@action
	async requestWinnerImage(params: IGetShareImageParams) {
		if (!params.contestId) {
			return;
		}
		const {data} = await this._predictionApiProvider.getWinnerShareImage(params);

		runInAction(() => {
			this._winnerShareImage = data.success.shareImage;
		});
	}
}
